module.exports = __webpack_public_path__ + "img/frame (75).bbaf33fe.jpg";